import { render, staticRenderFns } from "./ViewGatGridSlots.vue?vue&type=template&id=3fa715aa&scoped=true&"
import script from "./ViewGatGridSlots.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa715aa",
  null
  
)

export default component.exports